import { render, staticRenderFns } from "./LobbyList.vue?vue&type=template&id=61990822&"
import script from "./LobbyList.vue?vue&type=script&lang=js&"
export * from "./LobbyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LobbyList.vue"
export default component.exports